import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./common-components/layout/Layout";
import About from "./pages/about/About";
import Home from "./pages/home/Home";
import BlogArticle from "./pages/blogs/BlogArticle";
import InfiniteScrollUsingObserver from "./pages/questions/questions-list/InfiniteScrollUsingObserver/InfiniteScrollUsingObserver";
import InfiniteScrollUsingWindowScroll from "./pages/questions/questions-list/InfiniteScrollUsingWindowScroll/InfiniteScrollUsingWindowScroll";
import LruCache from "./pages/questions/questions-list/lruCache/LruCache";
import NestedComments from "./pages/questions/questions-list/nestedComments/NestedComments";
import Questions from "./pages/questions/Questions";

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        {/* <Route path="interview-questions">
          <Route index element={<Questions />} />
          <Route
            path={"infinite-scroll-using-intersection-observer"}
            element={<InfiniteScrollUsingObserver />}
          />
          <Route
            path={"infinite-scroll-using-window-scroll"}
            element={<InfiniteScrollUsingWindowScroll />}
          />
          <Route path={"lru-cache"} element={<LruCache />} />
          <Route path="nested-comments" element={<NestedComments />} />
        </Route> */}
        <Route path="about" element={<About />} />
        <Route path="blogs/:slug" element={<BlogArticle />} />
      </Route>
    </Routes>
  );
};

export default App;
